import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M43.3135 14.7135L37.7495 12.3124C34.7107 11.0005 31.275 10.9501 28.1981 12.1716L22.5659 14.4079C19.4905 15.6291 17.0251 18.0231 15.7139 21.0621L13.3127 26.6261C12.0009 29.6649 11.9504 33.1006 13.1719 36.1775L15.4083 41.8097C16.63 44.8859 19.0233 47.3511 22.0621 48.663L27.6261 51.0641C30.665 52.376 34.1006 52.4264 37.1775 51.2049L42.8097 48.9686C45.8859 47.7469 48.3511 45.3536 49.663 42.3148L52.0642 36.7507C53.376 33.7119 53.4264 30.2762 52.2049 27.1994L49.9686 21.5672C48.7469 18.4909 46.3536 16.0257 43.3148 14.7139L43.3135 14.7135Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCircle);
export default ForwardRef;
